import React, { useState } from "react";
import { Calendar } from "react-date-range";
import { Link, useNavigate } from "react-router-dom";
import LocationSelect from "../../maps/LocationSelect";
import useOutsideClick from "../../../hooks/useOutsideClick";
import { showToast } from "../../../utils/showToast";
import { useDispatch, useSelector } from "react-redux";
import {
  setHasSearched,
  setSearchParams,
} from "../../../redux/slices/vehicleSearchSlice";
import { enUS } from "date-fns/locale";

const Search: React.FC = () => {
  const user = useSelector((state: any) => state.user.user);
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [pickupLocation, setPickupLocation] = useState<{
    lat: number;
    lng: number;
    loc: string;
  } | null>(null);
  const [pickupDate, setPickupDate] = useState<string>("mm/dd/yy");
  const [pickupTime, setPickupTime] = useState<string>("");
  const [returnDate, setReturnDate] = useState<string>("mm/dd/yy");
  const [returnTime, setReturnTime] = useState<string>("");

  const [showPickupDate, setShowPickupDate] = useState<boolean>(false);
  const [showReturnDate, setShowReturnDate] = useState<boolean>(false);

  const handlePickupDateSelect = (date: any) => {
    setShowPickupDate(false);
    setShowReturnDate(false);
    setPickupDate(date.toLocaleDateString("en-US"));
  };

  const handleReturnDateSelect = (date: any) => {
    setShowReturnDate(false);
    setShowPickupDate(false);
    setReturnDate(date.toLocaleDateString("en-US"));
  };

  const handleSelectLocation = (lat: number, lng: number, loc: string) => {
    // console.log("location select", lat, lng, loc);

    setPickupLocation({ lat, lng, loc });
  };

  const pickupDateRef = React.useRef(null);
  const returnDateRef = React.useRef(null);

  useOutsideClick(pickupDateRef, () => {
    if (showPickupDate) {
      setShowPickupDate(false);
    }
  });

  useOutsideClick(returnDateRef, () => {
    if (showReturnDate) {
      setShowReturnDate(false);
    }
  });

  const handleSearch = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!pickupLocation) {
      showToast("Please select a pickup location", "error");
      return;
    }
    if (!pickupDate || pickupDate === "mm/dd/yy") {
      showToast("Please select a pickup date", "error");
      return;
    }
    if (!pickupTime) {
      showToast("Please select a pickup time", "error");
      return;
    }
    if (!returnDate || returnDate === "mm/dd/yy") {
      showToast("Please select a return date", "error");
      return;
    }
    if (!returnTime) {
      showToast("Please select a return time", "error");
      return;
    }
    if (pickupDate > returnDate) {
      showToast("Return date cannot be before pickup date", "error");
      return;
    }
    if (pickupDate === returnDate && pickupTime > returnTime) {
      showToast("Return time cannot be before pickup time", "error");
      return;
    }
    if (pickupDate === returnDate && pickupTime === returnTime) {
      showToast("Return time cannot be same as pickup time", "error");
      return;
    }

    dispatch(setHasSearched(true));
    dispatch(
      setSearchParams({
        pickupLocation,
        pickupDate,
        pickupTime,
        returnDate,
        returnTime,
      })
    );

    // if (!user) {
    //   showToast("Please login to continue", "error");
    //   setTimeout(() => {
    //     navigate("/auth");
    //   }, 2000);
    //   return;
    // }

    navigate("/vehicles");
  };

  return (
    <div className="w-[90%] md:w-5/6 mx-auto relative pb-7 bg-midGreen border rounded-lg flex flex-col space-y-10">
      <div className="flex items-center justify-center ">
        <div className="bg-fadeGreen p-[7px] rounded-lg -mt-[33px]">
          <div className=" bg-lightGreen rounded-lg">
            <h2 className="text-darkText px-5 py-4 font-Poppins text-[18px]  leading-tight text-edge-cap uppercase font-semibold">
              Make your trip
            </h2>
          </div>
        </div>
      </div>
      <div className="">
        <form
          action=""
          onSubmit={handleSearch}
          className="w-full p-[10px] lg:p-1 lg:w-5/6 flex flex-col xl:flex-row mx-auto font-Poppins font-[11px] text-lightText gap-5"
        >
          <div className="flex flex-col md:w-[80%]  md:mx-auto ">
            <label htmlFor="" className="md:text-center">
              {" "}
              Pickup Location
            </label>
            {/* <input
              type="text"
              value={pickupLocation}
              onChange={(e) => setPickupLocation(e.target.value)}
              placeholder="20 Cooper Square, New York, NY 10003, USA"
              className="border rounded-md px-5 lg:px-2 bg-transparent border-gray-300 text-[15px]   text-lightText font-Poppins py-2"
            /> */}
            <LocationSelect
              inputId="home-search-input"
              mapId="home-search-map"
              handleSelectLocation={handleSelectLocation}
              showMap={false}
              extraStyles="border rounded-md px-5 lg:px-2 bg-transparent border-gray-300 text-[13px]   text-white font-Poppins py-1"
            />
          </div>
          <div
            className="relative flex flex-row  gap-3 md:w-[80%]  md:mx-auto md:justify-between"
            ref={pickupDateRef}
          >
            <div className="flex flex-col w-1/2">
              <label htmlFor=""> Pickup Date</label>
              <div
                className="border h-12 rounded-md px-3 md:px-8 bg-transparent border-gray-300 text-[15px] text-center  text-lightText font-Poppins py-2 cursor-pointer "
                onClick={() => {
                  setShowPickupDate(!showPickupDate);
                  setShowReturnDate(false);
                }}
              >
                {pickupDate}
              </div>
            </div>
            <div className="w-full absolute top-[50px] left-0 ">
              {showPickupDate && (
                <Calendar
                  date={new Date()}
                  minDate={new Date()}
                  onChange={handlePickupDateSelect}
                  locale={enUS}
                />
              )}
            </div>

            <div className="flex flex-col w-1/2">
              <label htmlFor=""> Pickup Time</label>
              <input
                type="time"
                value={pickupTime}
                onChange={(e) => setPickupTime(e.target.value)}
                placeholder="12:00"
                className="border h-12 time-input rounded-md px-3 md:px-8 bg-transparent border-gray-300 text-[15px] text-center  text-lightText font-Poppins py-2 cursor-pointer"
              />
            </div>
          </div>
          <div
            ref={returnDateRef}
            className="relative flex flex-row  gap-3 md:w-[80%]  md:mx-auto md:justify-between"
          >
            <div className="flex flex-col w-1/2">
              <label htmlFor="">Return Date</label>
              <div
                className="border  h-12 date-input rounded-md px-3 md:px-8 bg-transparent border-gray-300 text-[15px] text-center  text-lightText font-Poppins py-2 cursor-pointer "
                onClick={() => {
                  setShowReturnDate(!showReturnDate);
                  setShowPickupDate(false);
                }}
              >
                {returnDate}
              </div>
            </div>
            <div className="w-full absolute top-[50px] left-0 ">
              {showReturnDate && (
                <Calendar
                  date={new Date()}
                  minDate={new Date()}
                  onChange={handleReturnDateSelect}
                  locale={enUS}
                />
              )}
            </div>

            <div className="flex flex-col w-1/2">
              <label htmlFor=""> Return Time</label>
              <input
                type="time"
                value={returnTime}
                onChange={(e) => setReturnTime(e.target.value)}
                placeholder="12:00"
                className="border h-12 time-input rounded-md px-3 md:px-8 bg-transparent border-gray-300 text-[15px] text-center  text-lightText font-Poppins py-2 cursor-pointer"
              />
            </div>
          </div>
          {/* <div className="w-full  md:w-[80%] mx-auto flex justify-center px-4 py-4 md:py-4 rounded-md bg-white cursor-pointer"> */}
          <button
            type="submit"
            className=" md:w-[80%] bg-white lg:w-full md:mx-auto py-4 lg:py-0 rounded-md  font-Poppins text-center text-darkText  text-[14px] font-medium"
          >
            Search
          </button>
          {/* </div> */}
        </form>
      </div>
    </div>
  );
};

export default Search;
